import { render, staticRenderFns } from "./TotalPondDetail.vue?vue&type=template&id=19086a64&scoped=true&"
import script from "./TotalPondDetail.vue?vue&type=script&lang=js&"
export * from "./TotalPondDetail.vue?vue&type=script&lang=js&"
import style0 from "./TotalPondDetail.vue?vue&type=style&index=0&id=19086a64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19086a64",
  null
  
)

export default component.exports